module.exports = __webpack_public_path__ + "static/media/angry0.031d8717.png";